import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [history, setHistory] = useState([]);
  useEffect(() => {
    api.get("/audit-logs").then(({ data }) => setRows(data)).catch(() => {});
    api.get("/auth/login-history").then(({ data }) => setHistory(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-primary">Compliance</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Audit trail</h1>
      </div>

      <Card className="shadow-sm">
        <CardContent className="p-0 max-h-[520px] overflow-y-auto">
          <Table data-testid="audit-table">
            <TableHeader>
              <TableRow>
                <TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Role</TableHead>
                <TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead>
                <TableHead>Device</TableHead><TableHead>IP</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                  <TableCell className="text-xs font-mono">{new Date(r.created_at).toLocaleString()}</TableCell>
                  <TableCell className="font-medium">{r.username}</TableCell>
                  <TableCell className="text-xs">{r.role}</TableCell>
                  <TableCell><Badge variant="outline" className="font-mono text-[10px]">{r.action}</Badge></TableCell>
                  <TableCell className="text-xs">{r.entity} {r.entity_id && `#${r.entity_id}`}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{r.details}</TableCell>
                  <TableCell className="text-xs font-mono">{r.device || "—"}</TableCell>
                  <TableCell className="text-xs font-mono">{r.ip || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <div>
        <h2 className="font-heading text-lg font-semibold mb-2">Login history</h2>
        <Card className="shadow-sm">
          <CardContent className="p-0 max-h-[320px] overflow-y-auto">
            <Table data-testid="login-history-table">
              <TableHeader>
                <TableRow><TableHead>Time</TableHead><TableHead>Username</TableHead>
                  <TableHead>Result</TableHead><TableHead>Device</TableHead><TableHead>IP</TableHead></TableRow>
              </TableHeader>
              <TableBody>
                {history.map((h) => (
                  <TableRow key={h.id}>
                    <TableCell className="text-xs font-mono">{new Date(h.created_at).toLocaleString()}</TableCell>
                    <TableCell>{h.username}</TableCell>
                    <TableCell>
                      <Badge variant={h.success ? "secondary" : "destructive"}>{h.success ? "Success" : "Failed"}</Badge>
                    </TableCell>
                    <TableCell className="text-xs">{h.device}</TableCell>
                    <TableCell className="text-xs font-mono">{h.ip}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
